var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AgreementModal,_vm._g(_vm._b({attrs:{"visible":_setup.modal.visible.value},on:{"close":_setup.onClose}},'AgreementModal',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }